// The store manages the state (private and public Collections)
// The actions update the server, commit the mutations, which then update local storage
//
// The updateChat action is where we deal with the fact that sub-chats are
// stored with their rootChat, but presented to the app as independent chats.
//
import Collection from '../../tts/collection'
import Vue from 'vue'
import APNGLoader from '../../apng'
import firebaseHelper from './firebaseHelper'
import defaultFaces from './defaultFaces'
import Firestore from '../../tts/firestore'
import firebase from 'firebase/app'
import userdocHelper from './userdocHelper'
// initial state
const state = {
  local: Collection({prefix: 'local_'}),
  defaultOptions: {},
  userdoc: {chats: {}, faces: {other: {}, uploads: {}}},
  bInitialized: false,
  localFaces: {},
  allFaces: {},
  chatsViewFaces: {},
  uid: null
}

const staticFaces = defaultFaces.faces

const getters = {
  chats: (state) => {
    if (state.local && state.local.chats) {
      return state.local.chats
    }
    return {}
  },
  userId: (state) => {
    return state.uid
  },
  localfaces: (state) => {
    return state.localFaces
  },
  allfaces: (state) => {
    return state.chatsViewFaces
  },
  bInitialized: (state) => {
    return state.bInitialized
  },
  defaultOptions: (state) => {
    return state.defaultOptions
  },
  currentChatId: (state) => {
    return state.currentChatId
  },
  remotechats: (state) => {
    return state.userdoc.chats
  }
}
const actions = {
  getPotentialDeletedFaces ({ commit, state, dispatch }, chatIdData) {
    var deletedUploads = userdocHelper.getUpdatedUserDoc({ commit, dispatch, state }, {chatId: chatIdData.chatId, data: null}).deletedUploads
    // Check local files?

    var localFiles = APNGLoader.getLocalAPNGs()
    var deletedLocalFiles = []
    var faces = Object.keys(chatIdData.data.faces)
    for (var i = 0; i < faces.length; ++i) {
      if (faces[i] in localFiles) {
        var bIsLocalFileInUse = false
        for (var chatId in state.local.chats) {
          if (chatId !== chatIdData.chatId && faces[i] in state.local.chats[chatId].faces) {
            bIsLocalFileInUse = true
            break
          }
        }
        if (!bIsLocalFileInUse) {
          deletedLocalFiles.push(faces[i])
        }
      }
    }
    return deletedUploads.concat(deletedLocalFiles)
  },
  getPotentialUploadedFaces ({ commit, state, dispatch }, chatIdData) {
    var localFaces = []
    for (var faceId in chatIdData.data.faces) {
      if (faceId in state.localFaces) {
        localFaces.push(faceId)
      }
    }
    return Promise.resolve(localFaces)
  },
  loadPrivateFromStorage ({ commit }) {
    commit('loadPrivateFromStorage')
  },
  updateDefaultOptions ({commit}, defaultOptions) {
    commit('updateDefaultOptions', defaultOptions)
  },
  loadLocalAPNG ({ commit, state, dispatch }, idApngThumb) {
    var apng = idApngThumb.apng
    var id = idApngThumb.id
    var thumb = idApngThumb.thumb
    var encoded = APNGLoader.getLocalAPNG(id, apng, thumb)
    encoded.id = id
    if (encoded.id && encoded.apng && encoded.thumb) {
      commit('saveLocalAPNGFile', encoded)
    } else {
      throw new Error('invalid file storage')
    }
    commit('updateFaces')
  },
  loadLocalAPNGs ({ commit, state, dispatch }) {
    var data = APNGLoader.getLocalAPNGs()
    for (var key in data) {
      if (data[key].apng && data[key].thumb) {
        data[key].id = key
        commit('saveLocalAPNGFile', data[key])
      } else {
        throw new Error('invalid file storage')
      }
    }
    commit('updateFaces')
  },
  uploadNewImage ({ commit, state }, data) {
    if (data.apng && data.thumb && data.faceId && data.chatIdData) {
      var userDocCopy = JSON.parse(JSON.stringify(state.userdoc))
      var chatIdDataCopy = JSON.parse(JSON.stringify(data.chatIdData))
      if (data.apng && data.thumb && data.faceId && data.chatIdData) {
        return firebaseHelper.uploadNewImage({ commit, state }, data.apng, data.thumb, data.faceId, chatIdDataCopy, userDocCopy).then(() => {
          commit('updateChat', chatIdDataCopy)
          commit('updateUserDoc', userDocCopy)
          commit('updateFaces')
        })
      }
    } else {
      throw new Error('Invalid args to uploadNewImage')
    }
  },
  uploadChatFaces: function ({ commit, state, dispatch }, chatIdData) {
    return firebaseHelper.uploadChatFaces({ commit, state, dispatch }, chatIdData).then(() => {
      commit('updateFaces')
    })
  },
  updateChatLocal ({ commit, state, dispatch }, chatIdData) {
    if (!chatIdData.data || !chatIdData.chatId) {
      throw new Error('NULL Chat or chat ID in updateChatLocal')
    }
    var updateWithString = JSON.stringify(chatIdData.data)
    if (!firebaseHelper.didChatChange({state}, chatIdData.chatId, updateWithString)) {
      return chatIdData
    } else {
      var timestamp = firebase.firestore.Timestamp.now()
      // var timestamp = Date.now()
      var updatedTimeStamp = JSON.parse(updateWithString)
      if (!updatedTimeStamp.firestore) {
        updatedTimeStamp.firestore = {}
        updatedTimeStamp.firestore.created = timestamp
        console.warn('no firestore data')
      }
      updatedTimeStamp.firestore.modified = timestamp
      commit('updateChat', {chatId: chatIdData.chatId, data: updatedTimeStamp})
      commit('updateFaces')
      return {chatId: chatIdData.chatId, data: updatedTimeStamp}
    }
  },
  updateChatLocalAndRemote ({ commit, state, dispatch }, chatIdData) {
    var chatId = chatIdData.chatId
    // Update the chat locally (if anything changed)
    // Then we can checkj the timestamp vs what we have in the userdoc
    dispatch('updateChatLocal', chatIdData).then((chatIdData) => {
      if (chatId in state.userdoc.chats) {
        if (Firestore.isMoreRecentThan(chatIdData.data, state.userdoc.chats[chatId])) {
          // We have a more recent local copy than what is on the server.
          var copy = JSON.parse(JSON.stringify(chatIdData))
          return firebaseHelper.updateChatLocalAndRemote({ commit, state, dispatch }, copy)
            .then((copy) => {
              commit('updateFaces')
              commit('updateChat', copy)
              return copy
            }).catch((error) => {
              console.warn('Error updating userdoc')
              console.error(error)
              throw error
            })
        } else {
          // console.warn('not updating server, up to date')
          // console.log(chatIdData.data.firestore.modified.seconds + '.' + chatIdData.data.firestore.modified.nanoseconds)
        }
      } else {
        // local-only chat
        return chatIdData
      }
    })
  },
  deleteFace ({ commit, state }, faceId) {
    if (faceId in state.userdoc.faces.uploads) {
      return firebaseHelper.deleteFace({ commit, state }, faceId)
    } else {
      var localFiles = APNGLoader.getLocalAPNGs()
      if (faceId in localFiles) {
        APNGLoader.deleteLocalAPNGFile(faceId)
        commit('deleteLocalAPNGFile', faceId)
      }
    }
    // this call does not automatically update the userdoc
  },
  deleteChat ({ commit, state }, chatId) {
    if (chatId in state.userdoc.chats) {
      firebaseHelper.deleteChat({ commit, state }, chatId).then(() => {
        commit('updateFaces')
      })
    } else {
      commit('deleteChat', chatId)
      commit('updateFaces')
    }
  },
  login ({ commit, state, dispatch }) {
    firebaseHelper.login({ commit, state, dispatch }).then(() => {
      commit('loadPrivateFromStorage')
      dispatch('loadLocalAPNGs').then(() => {
        commit('initialize')
      })
    })
  },
  downloadChat ({ commit, state, dispatch }, chatId) {
    if (chatId in state.local.chats && chatId in state.userdoc.chats) {
      if (Firestore.isMoreRecentThan(state.userdoc.chats[chatId], state.local.chats[chatId])) {
        return firebaseHelper.downloadChat({ commit, state, dispatch }, chatId)
      } else {
        return Promise.resolve(state.local.chats[chatId])
      }
    } else if (chatId in state.local.chats) {
      if (!state.local.chats[chatId].firestore || !state.local.chats[chatId].firestore.owner) {
        // never published
        return state.local.chats[chatId]
      }
      // Use local cache of chats that are not in userdoc.chats (other's chats?)?
      // How to know if it is up to date?  Perhaps record download time, and anything in the last hour use the cache?
      //
      // For now, we'll always download it again.
      return firebaseHelper.downloadChat({ commit, state, dispatch }, chatId)
    } else {
      // Old chat, new device
      return firebaseHelper.downloadChat({ commit, state, dispatch }, chatId)
    }
  },
  initialize ({ commit, state, dispatch }) {

  },
  createContent ({ commit, dispatch }, content) {
    var newId = Math.random().toString(36).substr(2, 8)
    commit('updateChat', {chatId: newId, data: content})
    return newId
  },
  createChatServer ({ commit, state, dispatch }, chatIdData) {
    return firebaseHelper.createChatServer({ commit, state, dispatch }, chatIdData).then((chatIdData) => {
      commit('updateFaces')
      return chatIdData
    })
  },
  setCurrentChatId ({ commit, state, dispatch }, chatId) {
    if (!state.bInitialized) {
      throw new Error('Not initialized')
    }
    return dispatch('downloadChat', chatId).then((chat) => {
      if (chat && chat.faces) {
        commit('updateFaces', chat.faces)
      }
      return chat
    })
  }
}
const mutations = {
  initialize (state) {
    state.bInitialized = true
  },
  updateDefaultOptions (state, defaultOptions) {
    state.defaultOptions = defaultOptions
  },
  updateChat (state, chatIdData) {
    if (chatIdData.data == null) {
      console.error('null')
    }
    state.lastModifiedChatId = chatIdData.chatId

    // Note:  Here and elsewhere, we use Vue.set to notify Vue of the change to
    // the store dictionary.  We then modify the store (a second time) via internal
    // function, which also updates the localStorage.  Vue.set must be called first
    // or no change is detected.
    Vue.set(state.local.chats, chatIdData.chatId, chatIdData.data)

    // Finally deal with local storage and update collection
    state.local.updateChat(chatIdData.chatId, state.local.chats[chatIdData.chatId])
  },
  updateUser (state, uid) {
    state.uid = uid
  },
  updateUserDoc (state, userdoc) {
    state.userdoc = userdoc
  },
  loadPrivateFromStorage (state) {
    state.local.loadFromStorage()

    var collection = Collection({prefix: state.local.prefix})
    collection.loadFromStorage()

    // We call Vue.set on the individual components primarily
    // So that we recognize when the face order changes (private faces first)
    Vue.set(state.local, 'faces', collection.faces)
    Vue.set(state.local, 'chats', collection.chats)
  },
  saveLocalAPNGFile (state, data) {
    if (data.id && data.thumb && data.apng) {
      state.localFaces[data.id] = {
        thumb: data.thumb,
        apng: data.apng}
    } else {
      throw new Error('invalid Data in saveLocalAPNGFile')
    }
  },
  deleteLocalAPNGFile (state, key) {
    if (key in state.localFaces) {
      Vue.delete(state.localFaces, key)
    }
  },
  deleteChat (state, id) {
    Vue.delete(state.local.chats, id)
    if (state.userdoc && state.userdoc.chats) {
      Vue.delete(state.userdoc.chats, id)
    }
    state.local.deleteChat(id)
  },
  // Additional faces can come from a non-owned chat
  updateFaces (state, additionalFaces) {
    state.chatsViewFaces = {}
    if (additionalFaces) {
      Object.assign(state.chatsViewFaces, state.chatsViewFaces, additionalFaces)
    }
    for (var chatId in state.local.chats) {
      for (var faceId in state.local.chats[chatId].faces) {
        Vue.set(state.chatsViewFaces, faceId, state.local.chats[chatId].faces[faceId])
      }
    }
    Object.assign(state.chatsViewFaces, state.localFaces, state.userdoc.faces.uploads, staticFaces, state.userdoc.faces.other)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/main.js